/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The incoterm reference of the shipment. FCA is available for DHL Express and FedEx only.
 *
 * @remarks
 * eDAP is available for DPD UK only. DAP is available for DHL Express and DPD UK.
 * If expecting DAP for other carriers, please use DDU.
 * Allowed values available <a href="#tag/Customs-Declaration-Incoterm">here</a>
 */
export const CustomsDeclarationIncotermEnum = {
  Ddp: "DDP",
  Ddu: "DDU",
  Fca: "FCA",
  Dap: "DAP",
  EDAP: "eDAP",
} as const;
/**
 * The incoterm reference of the shipment. FCA is available for DHL Express and FedEx only.
 *
 * @remarks
 * eDAP is available for DPD UK only. DAP is available for DHL Express and DPD UK.
 * If expecting DAP for other carriers, please use DDU.
 * Allowed values available <a href="#tag/Customs-Declaration-Incoterm">here</a>
 */
export type CustomsDeclarationIncotermEnum = ClosedEnum<
  typeof CustomsDeclarationIncotermEnum
>;

/** @internal */
export const CustomsDeclarationIncotermEnum$inboundSchema: z.ZodNativeEnum<
  typeof CustomsDeclarationIncotermEnum
> = z.nativeEnum(CustomsDeclarationIncotermEnum);

/** @internal */
export const CustomsDeclarationIncotermEnum$outboundSchema: z.ZodNativeEnum<
  typeof CustomsDeclarationIncotermEnum
> = CustomsDeclarationIncotermEnum$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace CustomsDeclarationIncotermEnum$ {
  /** @deprecated use `CustomsDeclarationIncotermEnum$inboundSchema` instead. */
  export const inboundSchema = CustomsDeclarationIncotermEnum$inboundSchema;
  /** @deprecated use `CustomsDeclarationIncotermEnum$outboundSchema` instead. */
  export const outboundSchema = CustomsDeclarationIncotermEnum$outboundSchema;
}
